import { Component, OnInit} from '@angular/core';
import { UserModel } from 'src/app/models/user.model';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { AuthService } from 'src/app/services/auth.service';
import { CommonHelper } from 'src/app/helpers/common';
declare var $: any;

@Component({
  styleUrls:['./header.component.css'],
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  public isIE: boolean =  false;
  public get currrentLanguage():string {
    return CommonHelper.storeLanguage;
  };
  public get flag():string{
    return this.currrentLanguage == 'es' ? '1' : '2';
  }

  userLogin$: Observable<UserModel>;
  public user: UserModel;

  constructor(private auth: AuthService, private commonHelper: CommonHelper, private router: Router) {
  
  }

  ngOnInit() {
    var isIE = navigator.userAgent.indexOf("MSIE") > -1;
    var isIE2 = navigator.userAgent.indexOf("Trident") > -1;

    if(isIE || isIE2){
      this.isIE = true;
    }
    
    this.getUser();

    this.userLogin$ = this.auth.getLoginAuthenticate$();
    this.userLogin$.subscribe(userModel => this.user = userModel);

    if(!this.user){
      this.getUser();
    }
  }

  getUser(){
    if(localStorage.getItem('user')){
      this.user = new UserModel(JSON.parse(localStorage.getItem('user')));
    }else{
      return false;
    }
  }

  logout(){
    this.auth.logout();
    this.router.navigateByUrl('/home')
  }


  changeLanguage(language: string){
    this.commonHelper.setLanguage(language);
    window.location.reload(true);
  }

  scrolling(position){
    
    if(location.pathname.substr(1)=="home" || location.pathname.substr(1)=="index" ){
      var elmnt = document.getElementById(position);
      elmnt.scrollIntoView({behavior: 'smooth'});
    }else{
      var myurl = position;
      this.router.navigateByUrl('/home').then(e => {
        if(e){
          var element = document.getElementById(position);
          element.scrollIntoView({behavior: 'smooth'});
        }
      });
    }
  }

  displayLoginForm(){
    $('#displayLoginForm').click();
  }

  openPage(url: string){
    this.router.navigateByUrl(url);
  }
  
}
